import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { async } from 'rxjs/internal/scheduler/async';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'app-client-user-list',
  templateUrl: './client-user-list.component.html',
  styleUrls: ['./client-user-list.component.scss'],
  standalone: true,
  imports: [CommonModule,MatMenuModule,MatButtonModule,MatIcon]
})
export class ClientUserListComponent implements OnInit {
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL+'uploads/';
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public userListingUrl = BaseUrlConstantsService.END_USER_LIST;
  public deleteUserUrl = BaseUrlConstantsService.DELETE_USERS;
  public pid: boolean;
  public showList: boolean;
  public emptyMsg: boolean;
  public checked = false;
  public clientList: any;
  public selectValueArr: any = [];
  public allClients: any = [];
  public showEmptyError: any = '';
  public selectedClientIDsArr: any = [];
  public breadcrumbsArray: any = [
    'users'
  ];
  public classAdd: any;
  company_name:string;
  today:any;
  constructor(
    private changeService: ChangeUsersService,
    public router: Router,
    private service: BackendApiService,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog) {
      this.utcTime();
      this.company_name = localStorage.getItem('company_name');
    }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();

      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  async selectListItem(event: any, index: number, id: number) {
    if (event.checked) {
      this.selectValueArr.push(id);
    } else {
      this.selectValueArr.splice(index, 1);
    }
    this.selectedClientIDsArr = Array.from(new Set(this.selectValueArr));
  }

  trackByFn(index, item) {
    return item.id;
  }

  ngOnInit() {
    this.getAllClients();
  }


  showDeleteDialog(id, index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      height: '205px',
      data: {
        type: 'delete-dialog-open',
        typeOf: 'user'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.deleteUser(id, index);
      }
    });
  }

  deleteUser(user_id, index) {
    this.service.deleteInfo(this.deleteUserUrl + "/" + user_id).then(res => {
      if (JSON.parse(JSON.stringify(res)).message.includes("User successfully deleted")) {
        this.classAdd = index;
        this.service.showSuccess('Successfully deleted');
        this.clientList.splice(index, 1);
        this.allClients.splice(index, 1);
        console.log(this.allClients,this.clientList,"this.allClients,this.clientList,")

      console.log(this.allClients.length,"this.allClients.length")
        if (this.allClients.length === 0) {

          this.service.getData(this.userListingUrl + "/" + Math.floor(Math.random() * 90 + 10) + localStorage.getItem('user_id') + Math.floor(Math.random() * 9000 + 1000) ).then(async (res) => {
          if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
            this.clientList = JSON.parse(JSON.stringify(res)).data.body;
            this.allClients = this.clientList;
          } else {

            this.service.showError('Something went wrong.');
          }
        });
          this.showEmptyError = "No users found!";
          this.showList = false;
         console.log(this.showList);
        }

      } else {
        this.service.showSuccess('Something went wrong.');
      }
    });
  }


  getAllClients() {
    this.changeService.loader(true);
    this.service.getData(this.userListingUrl + "/" + Math.floor(Math.random() * 90 + 10) + localStorage.getItem('user_id') + Math.floor(Math.random() * 9000 + 1000)).then(async (res) => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.clientList = JSON.parse(JSON.stringify(res)).data.body;
        this.allClients = this.clientList;
        //console.log(this.allClients ,"ingetall")
        if (this.clientList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    });
  }


  searchData(ev) {
    console.log(ev,"evvvv");
    //this.getAllClients();
    this.showList = true;
    if(ev ==""){
      console.log("hereemptyev")
      this.showEmptyError = '';
      this.showList=true;
      this.getAllClients();

    }
    else{
     //this.getAllClients();
    const term = ev.toLowerCase();
    this.allClients=this.clientList;
    console.log(this.allClients);
    console.log(this.allClients,"this.allClientsinsearchh");
    this.allClients = this.allClients.filter(
      tag => tag.full_name.toLowerCase().indexOf(term) >= 0 || tag.email.toLowerCase().indexOf(term) >= 0);
      console.log(this.allClients,"clientafterfilter");
    if (this.allClients.length === 0) {
      this.showEmptyError = 'No users found!';
    } else {
      this.showEmptyError = '';
    }

    }

  }

  async addClients() {
    this.router.navigate(['/add-user']);
  }

  async editClient(id) {
    let countryname= (this.allClients.filter(data => data.id==id))[0].country;
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        userId: id,
        countryname:countryname,
        pid: true,
        pageRef: 'admin-user'
      }
    };
    this.router.navigate(['/add-user'], navigationExtras);
  }


  async showLicense() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '650px',
      data: {
        type: 'adminLicense'
      }
    });
  }
}
